import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';

import './Navigation.css';

class Navigation extends Component {
  static propTypes = {
    mode: PropTypes.string,
    pathname: PropTypes.string
  };

  render() {
    return (
      <nav className={this.props.mode !== 'home' ? 'Navigation-root' : 'Navigation-root-home'} ref={node => (this.root = node)}>
        <div className={this.props.pathname.includes('/companies') ? 'Navigation-link activePage' : 'Navigation-link'} >
          <Link to='/companies'>COMPANIES</Link>
          { this.props.mode !== 'home' && <div className='Navigation-highlight' /> }
        </div>
        <div className={this.props.pathname.includes('/jobs') ? 'Navigation-link activePage' : 'Navigation-link'}>
          <Link to='/jobs'>JOBS</Link>
          { this.props.mode !== 'home' && <div className='Navigation-highlight' /> }
        </div>
      </nav>
    );
  }
}

const connectedNavigation = connect(state => ({
  pathname: state.router.location.pathname
}))(Navigation)

export default connectedNavigation;


// WEBPACK FOOTER //
// ./src/components/global/Navigation/Navigation.js